module.exports = __webpack_public_path__ + "static/media/even_better_image.55463572.png";